module.exports = __webpack_public_path__ + "img/11.e0ac7b14.jpg";